const fr = {
  // Navigation
  nav: {
    home: "Accueil",
    vision: "Ma Vision",
    services: "Accompagnements",
    articles: "Articles",
    contact: "Contact",
    logoText: "Management & Responsabilité",
  },

  // Hero Section
  hero: {
    title: "Vous dirigez.",
    titleHighlight: "Vous portez seul la cohérence de l'ensemble.",
    statement1: { pre: "Vous arbitrez entre ", bold1: "performance", mid: " et ", bold2: "humanité", post: "." },
    statement2: { pre: "Vous décidez ", bold1: "sans certitude", post: "." },
    statement3: { pre: "Vous portez seul la ", bold1: "cohérence de l'ensemble", post: "." },
    conclusionPre: "Cette tension est ",
    conclusionBold: "normale",
    conclusionDot: ".",
    emphasis: "L'éviter ne l'est pas.",
    cta: "Demander un échange confidentiel",
    profileAlt: "Loïc Blandel - Coach ICF & Formateur",
    manifestoLabel: "POUR QUI",
    manifestoText: "Je travaille avec ceux qui ",
    manifestoBold: "choisissent de l'affronter",
    manifestoPost: ".",
  },

  // Reality Section
  reality: {
    label: "RÉALITÉ",
    title: "Ce que peu de gens disent",
    s1: { pre: "Le management ", bold: "use", post: "." },
    s2: { pre: "Il ", bold: "expose", post: "." },
    s3: { pre: "Il ", bold: "isole", post: "." },
    s4: { pre: "Il oblige à ", bold: "décider sans certitude", post: "." },
    s5: { pre: "Il oblige à trancher entre ", bold: "performance", post: " et confort." },
    tensionsTitle: "Les tensions du quotidien :",
    tensions: [
      { bold: "Décisions différées", text: " qui s'accumulent et paralysent" },
      { bold: "Équipes instables", text: " malgré tous les efforts" },
      { bold: "Usure invisible", text: " du manager sous pression" },
      { bold: "Performance attendue", text: " sans marge d'erreur" },
      { bold: "Cohérence collective", text: " difficile à maintenir" },
    ],
    conclusion1: "Beaucoup parlent d'outils.",
    conclusion2: "Peu parlent de responsabilité.",
    conclusion3: "Je travaille avec ceux qui acceptent cette réalité.",
    tensionsTitle: "Les tensions du quotidien :",
  },

  // Clients Section
  clients: {
    label: "PROFIL",
    title: "Vous dirigez dans la complexité",
    intro: {
      pre: "Pour des ",
      bold: "dirigeants, membres de CODIR, entrepreneurs et directeurs opérationnels",
      post: " qui obtiennent des résultats ",
      bold2: "via les autres",
      post2: ".",
    },
    cards: ["Dirigeants", "Membres de CODIR", "Entrepreneurs en croissance", "Directeurs opérationnels", "Managers de premier niveau"],
    commonLabel: "Point commun :",
    commonText: "Ils doivent obtenir des résultats à travers les autres.",
  },

  // Results Section (Approche)
  results: {
    label: "APPROCHE",
    title: "Une approche structurée en 3 niveaux",
    intro: {
      pre: "Un accompagnement qui transforme la ",
      bold1: "vision",
      mid1: " en ",
      bold2: "exécution",
      mid2: " pour générer un ",
      bold3: "impact mesurable",
      post: ".",
    },
    levels: [
      {
        number: "1",
        title: "Vision",
        items: [
          "Clarté sur vos objectifs et priorités",
          "Cadre de décision lisible et partagé",
          "Vision alignée avec vos contraintes réelles",
        ],
      },
      {
        number: "2",
        title: "Exécution",
        items: [
          "Accompagnement de proximité à chaque étape structurante",
          "Amélioration du relationnel et des routines de travail",
          "Moins de décisions différées, plus de cohérence",
        ],
      },
      {
        number: "3",
        title: "Performance",
        items: [
          "Impact mesurable sur la qualité et les délais",
          "Réduction des frictions et de l'usure invisible",
          "Équipes plus stables, engagement renforcé",
        ],
      },
    ],
    conclusion1: "",
    conclusion2: "",
  },

  // Results conclusion (empty for FR - not used)
  // (conclusion fields added in results above if needed)

  // Framework Section (Expertise)
  framework: {
    label: "EXPERTISE",
    title: "Une expertise au service de votre contexte",
    intro: {
      bold1: "15 ans d'expérience en environnements industriels et opérationnels",
      text: ", où la pression des résultats est réelle et les décisions engagent des équipes entières. Cette expérience terrain me permet de ",
      bold2: "comprendre rapidement vos contraintes",
      post: " et d'adapter l'accompagnement à votre réalité, pas à un modèle théorique.",
    },
    stats: [
      { label: "Formation", value: "Ingénieur de formation", value2: "Coach professionnel certifié" },
      { label: "Expérience", valuePre: "Manager d'équipes jusqu'à ", accent: "100 personnes" },
      { label: "Impact", accent: "+100", valuePre: " managers accompagnés", detail: "(DRH, Directeurs industriels, Membres de CODIR)" },
      { label: "Individuel", accent: "30+", valuePre: " accompagnements individuels", detail: "(Fondateurs scale-ups, Directeurs opérationnels)" },
      { label: "Certification", certName: "ICF PCC", certDetail: "Professional Certified Coach" },
    ],
  },

  // Cofondateur Section
  cofondateur: {
    title: "Cofondateur",
    unipseDesc: "Société de conseil et coaching en management",
    cayusDesc: "Plateforme SaaS d'intelligence artificielle dédiée à prouver le ROI du leadership et piloter ses risques en entreprise",
  },

  // Vision Section
  vision: {
    label: "VISION",
    title: "L'exigence n'est pas une dureté. C'est une responsabilité.",
    intro: "Le management efficace n'est pas universel.",
    text: "Votre approche dépend de :",
    items: [
      "Votre personnalité et celle de vos équipes",
      "Votre contexte opérationnel spécifique",
      "Votre niveau de responsabilité",
      "Les systèmes déjà en place",
    ],
    quote1: "Henry Mintzberg a montré que le management ne peut être réduit à des modèles abstraits : il s'enracine dans la pratique réelle.",
    quote2: "Peter Drucker rappelait que la mission du management est de rendre une organisation capable de performance collective.",
    belief1: "Mon approche : pas de recettes toutes faites.",
    belief2: "Nous construisons ensemble la cohérence qui fonctionne pour vous.",
    footerPre: "",
    footerBold1: "Mon rôle",
    footerMid: " n'est pas d'imposer une méthode, mais de ",
    footerBold2: "vous aider à construire la vôtre",
    footerPost: " — celle qui tient dans la durée face à vos défis réels.",
  },

  // Accompagnements Section
  accompagnements: {
    label: "SERVICES",
    title: "Comment nous travaillons ensemble",
    intro: {
      pre: "Trois formats d'accompagnement, adaptés à vos enjeux et à votre contexte. ",
      bold: "Nous choisissons ensemble",
      post: " celui qui correspond le mieux à votre situation.",
    },
    cards: [
      {
        title: "Coaching professionnel 1 à 1",
        description: "Vous faites face à des enjeux managériaux complexes ? Nous construisons ensemble un cadre de réflexion et d'action adapté à <strong>votre</strong> contexte, <strong>votre</strong> personnalité et <strong>vos</strong> objectifs.",
      },
      {
        title: "Coaching situationnel terrain",
        description: "Vous avez besoin d'un regard extérieur sur une situation immédiate ? J'interviens directement dans <strong>votre</strong> environnement pour analyser et dénouer des situations concrètes, à vos côtés.",
      },
      {
        title: "Sparring partner",
        description: "Vous êtes dirigeant et cherchez un interlocuteur de confiance pour challenger vos décisions stratégiques ? Nous travaillons en duo : vous gardez la main, je vous aide à voir les angles morts.",
      },
    ],
  },

  // Testimonials Section
  testimonials: {
    label: "TÉMOIGNAGES",
    title: "Ce que disent mes clients",
    intro: "Retours de dirigeants et managers accompagnés dans leurs défis opérationnels.",
    featuredBadge: "Témoignage détaillé",
    measuredResults: "Résultats mesurés",
    cards: [
      {
        name: "Alfonso",
        role: "Directeur d'Usine",
        texts: [
          "J'ai eu le plaisir de travailler avec Loïc qui m'a <strong>inspiré</strong> et m'a aidé à trouver des moyens de surmonter des situations difficiles.",
          "Avec Loïc, j'ai pu développer des <strong>compétences managériales</strong> et continuer à progresser en matière de leadership. Un chemin qui ne s'arrête jamais.",
        ],
      },
      {
        name: "Geta",
        role: "Directrice Industrielle",
        featured: true,
        texts: [
          "La mission était de nous accompagner dans nos processus d'<strong>amélioration continue</strong> et de renforcer nos équipes de management intermédiaire. Sur ces deux points, <strong>le challenge a été relevé</strong>.",
          "J'ai fortement apprécié son <strong>écoute intelligente et objective</strong>, sans dogmatisme, pour adapter les solutions à la réalité de notre contexte.",
          "Sa grande force : <strong>donner du sens</strong> aux actions à mener et recentrer toujours les réflexions sur l'humain.",
        ],
      },
    ],
  },

  // Contact Section
  contact: {
    title: "Échangeons sur vos enjeux.",
    subtitle: "Chaque échange est strictement confidentiel.",
    photoAlt: "Loïc Blandel - Coach Management",
    cardTitle: "Coordonnées",
    cardSubtitle: "",
    emailLabel: "Email",
    phoneLabel: "Téléphone",
    linkedinLabel: "LinkedIn",
  },

  // Footer
  footer: {
    text: "© 2024 Management & Responsabilité. Tous droits réservés.",
  },

  // Articles Page
  articles: {
    backToHome: "Retour à l'accueil",
    title: "Articles & Actualité",
    subtitle: "Réflexions sur le leadership, le management et l'actualité des organisations",
    all: "Tout",
    loading: "Chargement des articles...",
    empty: "Aucun article publié pour le moment.",
    news: "Actualité",
    article: "Article",
    min: "min",
  },

  // Article Detail
  articleDetail: {
    backToArticles: "Retour aux articles",
    notFound: "Article non trouvé",
    loading: "Chargement de l'article...",
    share: "Partager",
    copyLink: "Copier le lien",
    readingTime: "min de lecture",
    by: "Par",
    externalNotice: "Cet article provient d'une source externe.",
    readOriginal: "Lire l'article original",
    linkCopied: "Lien copié dans le presse-papier !",
  },
};

export default fr;
